import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-disclaimer',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    FormsModule
  ],
  templateUrl: './disclaimer.component.html',
  styleUrl: './disclaimer.component.scss'
})
export class DisclaimerComponent {
  @Input() showDisclaimerDialog: boolean = false;
  @Output() showDisclaimerDialogChange = new EventEmitter<boolean>();

  constructor(private userService: UserService) {
    }

  closeDisclaimerDialog() {
    this.userService.updateUserDisclaimerAcceptedDate();
    this.showDisclaimerDialog = false;
    this.showDisclaimerDialogChange.emit(this.showDisclaimerDialog);
  }
}
